import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Button } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { creatHotelCategory, updateHotelCategory } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Category-Create.scss';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { useDispatch } from 'react-redux';
import { fetchAllAccommodations } from '../../../../property/propertySlice';
import './Category-Create.scss';
import { formDataValidate } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const CategoryCreate = (props) => {
  const { toggleDrawer, category, hotelId, showLoader } = props;
  const dispatch = useDispatch();
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      placeholder: '(Ex: Villa, Apartment)',
      tab: 0,
    },
  });

  useEffect(() => {
    if (category) {
      const currFields = { ...formData };
      currFields.code.value = category.code;
      currFields.name.value = category.name;

      setFormData(currFields);
    }
  }, [category]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        if (category) {
          await updateHotelCategory(
            {
              name: formData.name.value,
              code: formData.code.value,
              id: category.id,
            },
            hotelId,
            language,
          );
          notificationManager('success', 'Category updated successfully');
        } else {
          await creatHotelCategory(
            { name: formData.name.value, code: formData.code.value },
            hotelId,
            language,
          );
          notificationManager('success', 'Category created successfully');
        }
        dispatch(fetchAllAccommodations(hotelId));
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          category
            ? notificationManager('danger', 'Category updation failed')
            : notificationManager('danger', 'Category creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{category ? 'Edit Category' : 'Add Category'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title-secondary'>Category details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-3'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={8}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid}
            >
              {category ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CategoryCreate;
